import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function NastavnoOsoblje() {
  const [t] = useTranslation();

  const teachers = [
    {
      name: "Prof. dr Rajko Novićević",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "dr Đorđije Pavićević",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Doc. dr Nikola Abramović",
      role: "",
      image: "assets/img/team/NikolaAbramovic.png",
    },
    {
      name: "Prof. dr Sandra Đurović",
      role: "",
      image: "assets/img/team/SandraDjurovic.png",
    },

    {
      name: "Prof. dr Veselin Orlandić",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Momčilo Živković",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Rade Kancir",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Aleksa Macanović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Sonja Pravilović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Marko Malović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Irena Petrušić",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Gordana Nikčević",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Doc. dr Nataša Perović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Ivana Rašović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Vladan Martić",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Doc. dr Ivana Tomašević",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Dražen Božović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Miodrag Živanović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Ognjen Vujović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Dejan Mirović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Sanja Danković-Stepanović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Đuro Đurić",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Savo Marković",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Branko Vučković",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Bojan Bojanić",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Prof. dr Živko Kulić",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Doc. dr Slađana Živanović",
      role: "",
      image: "assets/img/team/privremena.png",
    },

    {
      name: "mr Stefan Đurić",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "mr Nermin Škretović",
      role: "",
      image: "assets/img/team/NerminSkretovic.jpg",
    },
    {
      name: "mr Anđela Janković",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "mr Nedžad Lajka",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "mr Dejana Crvenica",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "mr Žana Janković",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "mr Velimir Drecun",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "SSc Filip Kankaraš",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "SSc Andro Drecun",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "mr Katarina Petrović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "mr Aleksandra Matović",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "Msc Dijana Drobnjak",
      role: "",
      image: "assets/img/team/privremena.png",
    },
    {
      name: "mr Milica Anđelić",
      role: "",
      image: "assets/img/team/privremena.png",
    },
  ];
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Nastavno osoblje" />
      <>
        <section className="team-area2 fix p-relative pt-120 pb-80">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 p-relative">
                <div
                  className="section-title center-align mb-50 text-center wow fadeInDown animated"
                  data-animation="fadeInDown"
                  data-delay=".4s"
                >
                  <h5>
                    <i className="fas fa-graduation-cap" /> {t("nastavno.cap")}
                  </h5>
                  <h2>{t("nastavno.title")}</h2>
                </div>
              </div>
            </div>
            <div className="row">
              {teachers.map((teacher, index) => (
                <div key={index} className="col-xl-3 col-md-6">
                  <div className="single-team mb-40">
                    <div className="team-thumb">
                      <div className="brd">
                        <Link>
                          <img src={teacher.image} alt="img" />
                        </Link>
                      </div>
                    </div>
                    <div className="team-info">
                      <h4>
                        <Link>{teacher.name}</Link>
                      </h4>
                      <p>{teacher.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </>
      <Footer />
    </>
  );
}
export default NastavnoOsoblje;
